import { z } from 'zod';

export const objectIdRegex = /^[0-9a-f]{24}$/;

export const objectIdSchema = z
  .string()
  .regex(objectIdRegex, 'Invalid ObjectId');

export const isObjectId = (str: string) => objectIdRegex.test(str);
